export const companyData = {
  site: "https://www.devpunks.com",
  name: "Devpunks",
  description: "",
  cover: "",
  address: {
    street: "Via Vincenzo Lancia 31/20",
    locality: "Torino",
    region: "Torino",
    postalCode: "10141",
    country: "Italia",
  },
}
